import { render, staticRenderFns } from "./clinicMaster.vue?vue&type=template&id=d713033c&"
import script from "./clinicMaster.vue?vue&type=script&lang=js&"
export * from "./clinicMaster.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports